// CURRENTLY NO LINKS TO THIS PAGE, MAY BE USED AGAIN IN THE FUTURE (IF NOT MERGED)

import { useEffect, useState } from "react";

import { Button, Divider, FormControl, FormErrorMessage, FormLabel, Input, Textarea, useDisclosure, useToast } from "@chakra-ui/react"
import { Field, Form, Formik } from "formik"
import { useNavigate } from "react-router-dom"
import { HttpStatusCode } from "axios";
import { format } from "date-fns";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import ArrowIcon from "@/assets/ArrowIcon";
import AddOthersIcon from "@/assets/AddOthersIcon";
import RemoveOthersIcon from "@/assets/RemoveOthersIcon";
import FileUploader from "@/components/Fields/FileUploader";
import ModalConfirmation from "@/components/Modals/ModalConfirmation";
import CurrencyInput from "@/components/Fields/CurrencyInput";
import SelectCountry from "@/components/Selects/SelectCountry";
import SelectShip from "@/components/Selects/SelectShip";
import SelectCurrency from "@/components/Selects/SelectCurrency";
import SelectTypeShipOperator from "@/components/Selects/SelectTypeShipOperator";
import { COLORS, DURATION_TOAST, FORMAT_ADD_DATE, INVOICE_STATUS, PAYMENT_STATUS } from "@/common/constants";
import currency from "@/data/currency";
import { useAppSelector } from "@/redux/hooks";
import { RootState } from "@/redux/store";
import { invoiceInspectorSchema } from "@/schemas/invoiceInspectorSchema";
import { postInvoiceInspector } from "@/services/invoicesInspectorService";
import { getDataVessel } from "@/services/vesselService";
import { parseCurrencyFloat } from "@/utils/currency";

import './customDatepicker.css';

const AddInvoicesInspector = () => {
    const navigate = useNavigate();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const toast = useToast();
    const role = useAppSelector((state: RootState) => state.account.roleName);
    const inspectorId = useAppSelector((state: RootState) => state.account.appId);
    const inspectorName = useAppSelector((state: RootState) => state?.account?.companyName);
    const isReviewer = useAppSelector((state: RootState) => state.account.isReviewer);

    const [awaitingDays, setAwaitingDays] = useState(0);
    const [awaitingCost, setAwaitingCost] = useState(0);
    const [costInspection, setCostInspection] = useState(0);
    const [confirmationText, setConfirmationTest] = useState("");
    const [confirmationTitleButton, setConfirmationTitleButton] = useState("");
    const [dataAdd, setDataAdd] = useState(null) as any;
    const [isDraft, setIsDraft] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [listShipName, setListShipName] = useState([]) as any;
	const [prefix, setPrefix] = useState('IDR');
    const [total, setTotal] = useState(0);
    const [total1, setTotal1] = useState(0);
    const [total2, setTotal2] = useState(0);
    const [total3, setTotal3] = useState(0);
    const [total4, setTotal4] = useState(0);
    const [total5, setTotal5] = useState(0);
    const [total6, setTotal6] = useState(0);
    const [total7, setTotal7] = useState(0);
    const [total8, setTotal8] = useState(0);
    const [total9, setTotal9] = useState(0);
    const [total10, setTotal10] = useState(0);
    const [uploadedFiles, setUploadedFiles] = useState<File[]>() as any;
    const [visibleOthers, setVisibleOthers] = useState([1]);
    const [title, setTitle] = useState("");

    const handleCancel = () => {
        onOpen();
        setTitle("Cancel to Create Invoice?");
        setConfirmationTest("Are you sure you want to cancel?");
        setConfirmationTitleButton("Yes");
    }

    const handleSubmit = (data: any) => {
        if (isDraft) {
            setTitle("Save Invoice?");
            setConfirmationTest("Are you sure you want to save invoice as draft?");
            setConfirmationTitleButton("Save Invoice");
        } else {
            setTitle("Create Invoice?");
            setConfirmationTest("Are you sure you want to create?");
            setConfirmationTitleButton("Create Invoice");
        }

        onOpen();
        setDataAdd(data);
        setIsSubmitting(true);
    }

    const generateDataAdd = () => {
        const data = new FormData();
        const vesselData = listShipName.find((x: any) => x.value === dataAdd.shipName);

        data.append('sireType', dataAdd.sireType || '');
        data.append('inspectorId', inspectorId);
        data.append('sequenceID', '');
        data.append('inspectorName', inspectorName);
        data.append('vesselId', vesselData?.value || '');
        data.append('invoiceNumber', dataAdd.invoiceNumber);
        data.append('shipName', vesselData?.label || '');
        data.append('invoiceDate', dataAdd.invoiceDate ? format(dataAdd.invoiceDate, FORMAT_ADD_DATE) : '');
        data.append('inspectionDate', dataAdd.inspectionDate ? format(dataAdd.inspectionDate, FORMAT_ADD_DATE) : '');
        data.append('country', dataAdd.country);
        data.append('port', dataAdd.port);
        data.append('jobDescription', dataAdd.jobDescription);
        data.append('costInspection', dataAdd.costInspection ? parseCurrencyFloat(dataAdd.costInspection).toString() : '');
        data.append('awaitingDays', dataAdd.awaitingDays ? parseCurrencyFloat(dataAdd.awaitingDays).toString() : '');
        data.append('awaitingDaysCost', dataAdd.awaitingCost ? parseCurrencyFloat(dataAdd.awaitingCost).toString() : '');
        data.append('other1', dataAdd.other1 ?? '');
        data.append('otherCost1', dataAdd.otherCost1 ? parseCurrencyFloat(dataAdd.otherCost1).toString() : '');
        data.append('otherEvidence1File', dataAdd.otherCostFile1 ?? '');
        data.append('other2', dataAdd.other2 ?? '');
        data.append('otherCost2', dataAdd.otherCost2 ? parseCurrencyFloat(dataAdd.otherCost2).toString() : '');
        data.append('otherEvidence2File', dataAdd.otherCostFile2 ?? '');
        data.append('other3', dataAdd.other3 ?? '');
        data.append('otherCost3', dataAdd.otherCost3 ? parseCurrencyFloat(dataAdd.otherCost3).toString() : '');
        data.append('otherEvidence3File', dataAdd.otherCostFile3 ?? '');
        data.append('other4', dataAdd.other4 ?? '');
        data.append('otherCost4', dataAdd.otherCost4 ? parseCurrencyFloat(dataAdd.otherCost4).toString() : '');
        data.append('otherEvidence4File', dataAdd.otherCostFile4 ?? '');
        data.append('other5', dataAdd.other5 ?? '');
        data.append('otherCost5', dataAdd.otherCost5 ? parseCurrencyFloat(dataAdd.otherCost5).toString() : '');
        data.append('otherEvidence5File', dataAdd.otherCostFile5 ?? '');
        data.append('other6', dataAdd.other6 ?? '');
        data.append('otherCost6', dataAdd.otherCost6 ? parseCurrencyFloat(dataAdd.otherCost6).toString() : '');
        data.append('otherEvidence6File', dataAdd.otherCostFile6 ?? '');
        data.append('other7', dataAdd.other7 ?? '');
        data.append('otherCost7', dataAdd.otherCost7 ? parseCurrencyFloat(dataAdd.otherCost7).toString() : '');
        data.append('otherEvidence7File', dataAdd.otherCostFile7 ?? '');
        data.append('other8', dataAdd.other8 ?? '');
        data.append('otherCost8', dataAdd.otherCost8 ? parseCurrencyFloat(dataAdd.otherCost8).toString() : '');
        data.append('otherEvidence8File', dataAdd.otherCostFile8 ?? '');
        data.append('other9', dataAdd.other9 ?? '');
        data.append('otherCost9', dataAdd.otherCost9 ? parseCurrencyFloat(dataAdd.otherCost9).toString() : '');
        data.append('otherEvidence9File', dataAdd.otherCostFile9 ?? '');
        data.append('other10', dataAdd.other10 ?? '');
        data.append('otherCost10', dataAdd.otherCost10 ? parseCurrencyFloat(dataAdd.otherCost10).toString() : '');
        data.append('otherEvidence10File', dataAdd.otherCostFile10 ?? '');
        data.append('subTotalCost', total.toString());
        data.append('totalAmount', total.toString());
        data.append('currency', currency.find((x: any) => x.value === dataAdd.currency)?.label ?? '');
        if (uploadedFiles?.length > 0) {
            for (let i = 0; i < uploadedFiles?.length; i++) {
                data.append('files', uploadedFiles[i]);
            }
        } else {
            data.append('files', '');
        }
        data.append('InspectionResultfile', dataAdd.inspectionResult || '');
        data.append('invoiceStatus', isDraft ? String(INVOICE_STATUS.DRAFT) : String(INVOICE_STATUS.IN_PROGRESS));
        data.append('paymentStatus', String(PAYMENT_STATUS.UNPAID));
        data.append('note', dataAdd.note);
        // for (let [key, value] of data.entries()) {
        //     console.log(`${key}: ${value}`);
        // }
        return data;
    }

    const handleConfirm = async () => {
        onClose();

        if (title === "Cancel to Create Invoice?") {
            navigate(role === 'super admin' ? '/manage-invoices/inspecting-company' : '/manage-invoices-inspecting-company');
            return;
        }

        const obj = generateDataAdd();
        const response = await postInvoiceInspector(obj) as any;
        setIsSubmitting(false);
        if (response?.status === HttpStatusCode.Ok) {
            toast({
                title: 'Invoice created.',
                description: "We've created invoice for you.",
                status: 'success',
                duration: DURATION_TOAST,
                isClosable: true,
            });

            setTimeout(() => {
                navigate(role === 'super admin' ? '/manage-invoices/inspecting-company' : '/manage-invoices-inspecting-company');
            }, 1000)
        } else {
            toast({
                title: 'Invoice failed to create.',
                description: "We unabled to create invoice for you.",
                status: 'error',
                duration: DURATION_TOAST,
                isClosable: true,
            });
        }
    }

    const handleDrop = (acceptedFiles: File[], fieldName: string, setFieldValue: any) => {
        setUploadedFiles(acceptedFiles);
        setFieldValue(fieldName, acceptedFiles);
    };

    const handleAddOthers = (index: number, isSubmitting: boolean) => {
        if (isSubmitting) {
            return;
        }

        const isExist = visibleOthers.includes(index + 1);
        if (!isExist) {
            setVisibleOthers([...visibleOthers, index + 1]);
        }
    }

    const handleRemoveOthers = (index: number, isSubmitting: boolean) => {
        if (isSubmitting) {
            return;
        }

        const isExist = visibleOthers.includes(index);
        if (isExist) {
            const newArr = visibleOthers.filter((x: number) => x !== index);
            setVisibleOthers(newArr);

            if (index === 1) {
                setTotal1(0);
            } else if (index === 2) {
                setTotal2(0);
            } else if (index === 3) {
                setTotal3(0);
            } else if (index === 4) {
                setTotal4(0);
            } else if (index === 5) {
                setTotal5(0);
            } else if (index === 6) {
                setTotal6(0);
            } else if (index === 7) {
                setTotal7(0);
            } else if (index === 8) {
                setTotal8(0);
            } else if (index === 9) {
                setTotal9(0);
            } else if (index === 10) {
                setTotal10(0);
            }
        }
    }

    const handleConfirmToCancel = () => {
        setIsSubmitting(false);
        onClose();
    }

    const handleChangeCostInspection = (value: number, setFieldValue: any) => {
        setFieldValue(`costInspection`, value);
        setCostInspection(value);
    }

    const handleChangeAwaitingDays = (value: number, setFieldValue: any) => {
        setFieldValue(`awaitingDays`, value);
        setAwaitingDays(value);
    }

    const handleChangeAwaitingCost = (value: number, setFieldValue: any) => {
        setFieldValue(`awaitingCost`, value);
        setAwaitingCost(value);
    }

    const handleChangeOtherCost = (index: number, value: number, setFieldValue: any) => {
        //setTotal(0);

        if (index === 1) {
            setTotal1(value);
            setFieldValue(`otherCost1`, value);
        } else if (index === 2) {
            setTotal2(value);
            setFieldValue(`otherCost2`, value);
        } else if (index === 3) {
            setTotal3(value);
            setFieldValue(`otherCost3`, value);
        } else if (index === 4) {
            setTotal4(value);
            setFieldValue(`otherCost4`, value);
        } else if (index === 5) {
            setTotal5(value);
            setFieldValue(`otherCost5`, value);
        } else if (index === 6) {
            setTotal6(value);
            setFieldValue(`otherCost6`, value);
        } else if (index === 7) {
            setTotal7(value);
            setFieldValue(`otherCost7`, value);
        } else if (index === 8) {
            setTotal8(value);
            setFieldValue(`otherCost8`, value);
        } else if (index === 9) {
            setTotal9(value);
            setFieldValue(`otherCost9`, value);
        } else if (index === 10) {
            setTotal10(value);
            setFieldValue(`otherCost10`, value);
        }
    }

    const handleChangeCurrency = (props: any, value: string) => {
        props.setFieldValue('currency', value);
        setPrefix(value);
    }

    const getListShipName = async () => {
        const response = await getDataVessel() as any;
        if (response.status === HttpStatusCode.Ok) {
            const formattedOptions = response.data.map((item: any) => ({ value: item.vesselId, label: item.vesselName }));
            setListShipName(formattedOptions);
        }
    }

    useEffect(() => {
        getListShipName();
    }, []);

    useEffect(() => {
        const awaitingFee = awaitingDays * awaitingCost;

        const total = (costInspection ? Number(costInspection) : 0) +
            (awaitingFee ? Number(awaitingFee) : 0) +
            (total1 ? Number(total1) : 0) +
            (total2 ? Number(total2) : 0) +
            (total3 ? Number(total3) : 0) +
            (total4 ? Number(total4) : 0) +
            (total5 ? Number(total5) : 0) +
            (total6 ? Number(total6) : 0) +
            (total7 ? Number(total7) : 0) +
            (total8 ? Number(total8) : 0) +
            (total9 ? Number(total9) : 0) +
            (total10 ? Number(total10) : 0);
        setTotal(total);
    }, [
        costInspection,
        awaitingDays,
        awaitingCost,
        total1,
        total2,
        total3,
        total4,
        total5,
        total6,
        total7,
        total8,
        total9,
        total10
    ]);

    return (
        <>
            <ModalConfirmation isOpen={isOpen} onClose={onClose} title={title} handleCancel={handleConfirmToCancel} handleConfirm={handleConfirm} confirmationText={confirmationText} confirmButtonText={confirmationTitleButton} />
            <div className="form-container">
                <Formik
                    initialValues={{
                        sireType: '',
                        invoiceNumber: '',
                        shipName: '',
                        inspectionDate: '',
                        invoiceDate: '',
                        country: '',
                        port: '',
                        jobDescription: '',
                        costInspection: null,
                        awaitingDays: '',
                        awaitingCost: null,
                        others1: '',
                        otherCost1: null,
                        otherCostFile1: null,
                        others2: '',
                        otherCost2: null,
                        otherCostFile2: null,
                        others3: '',
                        otherCost3: null,
                        otherCostFile3: null,
                        others4: '',
                        otherCost4: null,
                        otherCostFile4: null,
                        others5: '',
                        otherCost5: null,
                        otherCostFile5: null,
                        others6: '',
                        otherCost6: null,
                        otherCostFile6: null,
                        others7: '',
                        otherCost7: null,
                        otherCostFile7: null,
                        others8: '',
                        otherCost8: null,
                        otherCostFile8: null,
                        others9: '',
                        otherCost9: null,
                        otherCostFile9: null,
                        others10: '',
                        otherCost10: null,
                        otherCostFile10: null,
                        totalAmount: 0,
							currency: 'IDR',
                        files: null,
                        inspectionResult: null,
                        invoiceStatus: 0,
                        paymentStatus: 0,
                        note: ''
                    }}
                    validationSchema={() => invoiceInspectorSchema(isDraft, [], false, '', isReviewer)}
                    onSubmit={(values) => {
                        handleSubmit(values);
                    }}
                >
                    {(props) => (
                        <Form>
                            {isReviewer && <Field name='sireType'>
                                {({ form }: any) => (
                                    <FormControl isInvalid={form.errors.sireType && form.touched.sireType} style={{ marginBottom: 15 }}>
                                        <div className="form-field-container">
                                            <FormLabel className="form-label">SIRE Type<span style={{ color: 'red' }}>*</span></FormLabel>
                                            <div className="form-input-container">
                                                <SelectTypeShipOperator
                                                    name='sireType'
                                                    placeholder="Choose Type"
                                                    handleChange={({ value }: { value: string }) => form.setFieldValue('sireType', value)}
                                                    value={form.values.sireType}
                                                    hasError={form.errors.sireType && form.touched.sireType}
                                                    defaultValue={props.values.sireType}
                                                />
                                                <FormErrorMessage>{form.errors.sireType}</FormErrorMessage>
                                            </div>
                                        </div>
                                        
                                    </FormControl>
                                )}
                            </Field>}
                            <Field name='invoiceNumber'>
                                {({ field, form }: any) => (
                                    <FormControl isInvalid={form.errors.invoiceNumber && form.touched.invoiceNumber} style={{ marginBottom: 15 }}>
                                        <div className="form-field-container">
                                            <FormLabel className="form-label">Invoice Number<span style={{ color: 'red' }}>*</span></FormLabel>
                                            <div className="form-input-container">
                                                <Input {...field} placeholder='Invoice Number' className="form-input" isDisabled={isSubmitting} />
                                                <FormErrorMessage>{form.errors.invoiceNumber}</FormErrorMessage>
                                            </div>
                                        </div>
                                    </FormControl>
                                )}
                            </Field>
                            <Field name='shipName'>
                                {({ form }: any) => (
                                    <FormControl isInvalid={form.errors.shipName && form.touched.shipName} style={{ marginBottom: 15 }}>
                                        <div className="form-field-container">
                                            <FormLabel className="form-label">Vessel Name<span style={{ color: 'red' }}>*</span></FormLabel>
                                            <div className="form-input-container">
                                                <SelectShip name='shipName' placeholder="Choose Ship" handleChange={({ value }: any) => props.setFieldValue('shipName', value)} value={props.values.shipName} options={listShipName} hasError={form.errors.shipName && form.touched.shipName} isDisabled={isSubmitting} />
                                                <FormErrorMessage>{form.errors.shipName}</FormErrorMessage>
                                            </div>
                                        </div>
                                    </FormControl>
                                )}
                            </Field>
                            <Field name="inspectionDate">
                                {({ form, field }: any) => (
                                    <FormControl isInvalid={form.errors.inspectionDate && form.touched.inspectionDate} style={{ marginBottom: 15 }}>
                                        <div className="form-field-container">
                                            <FormLabel className="form-label">Inspection Date<span style={{ color: 'red' }}>*</span></FormLabel>
                                            <div style={{
                                                width: '100%',
                                                height: '2.5rem',
                                                fontSize: '1rem',
                                                paddingInlineStart: '1rem',
                                                paddingInlineEnd: '1rem',
                                                borderRadius: '0.375rem',
                                                minWidth: '0px',
                                                outline: '2px solid transparent',
                                                outlineOffset: '2px',
                                                position: 'relative',
                                                appearance: 'none',
                                                transitionProperty: 'background-color, border-color, color, fill, stroke, opacity, box-shadow, transform',
                                                paddingTop: '0.35rem',
                                                marginBottom: (form.errors.inspectionDate && form.touched.inspectionDate) ? '1.25rem' : 0,
                                                border: form.errors.inspectionDate && form.touched.inspectionDate ? '2px solid red' : '1px solid #e5e7e9'
                                            }}>
                                                <DatePicker
                                                    id="inspectionDate"
                                                    selected={field.value as Date | null}
                                                    onChange={(date: Date | null) => props.setFieldValue('inspectionDate', date)}
                                                    dateFormat="dd-MM-YYYY"
                                                    placeholderText="Inspection Date"
                                                    readOnly={isSubmitting}
                                                />
                                                <FormErrorMessage>{form.errors.inspectionDate}</FormErrorMessage>
                                            </div>
                                        </div>
                                    </FormControl>
                                )}
                            </Field>
                            <Field name='invoiceDate'>
                                {({ field, form }: any) => (
                                    <FormControl isInvalid={form.errors.invoiceDate && form.touched.invoiceDate} style={{ marginBottom: 15 }}>
                                        <div className="form-field-container">
                                            <FormLabel className="form-label">Invoice Date<span style={{ color: 'red' }}>*</span></FormLabel>
                                            <div style={{
                                                width: '100%',
                                                height: '2.5rem',
                                                fontSize: '1rem',
                                                paddingInlineStart: '1rem',
                                                paddingInlineEnd: '1rem',
                                                borderRadius: '0.375rem',
                                                minWidth: '0px',
                                                outline: '2px solid transparent',
                                                outlineOffset: '2px',
                                                position: 'relative',
                                                appearance: 'none',
                                                transitionProperty: 'background-color, border-color, color, fill, stroke, opacity, box-shadow, transform',
                                                paddingTop: '0.35rem',
                                                marginBottom: (form.errors.invoiceDate && form.touched.invoiceDate) ? '1.25rem' : 0,
                                                border: form.errors.invoiceDate && form.touched.invoiceDate ? '2px solid red' : '1px solid #e5e7e9'
                                            }}>
                                                <DatePicker
                                                    id="invoiceDate"
                                                    selected={field.value as Date | null}
                                                    onChange={(date: Date | null) => props.setFieldValue('invoiceDate', date)}
                                                    dateFormat="dd-MM-YYYY"
                                                    placeholderText="Invoice Date"
                                                    readOnly={isSubmitting}
                                                />
                                                <FormErrorMessage>{form.errors.invoiceDate}</FormErrorMessage>
                                            </div>
                                        </div>
                                    </FormControl>
                                )}
                            </Field>
                            <Field name='country'>
                                {({ form }: any) => (
                                    <FormControl isInvalid={form.errors.country && form.touched.country} style={{ marginBottom: 15 }}>
                                        <div className="form-field-container">
                                            <FormLabel className="form-label">Country<span style={{ color: 'red' }}>*</span></FormLabel>
                                            <div className="form-input-container">
                                                <SelectCountry name='country' placeholder="Choose Country" handleChange={({ value }: any) => props.setFieldValue('country', value)} value={props.values.country} hasError={form.errors.country && form.touched.country} isDisabled={isSubmitting} />
                                                <FormErrorMessage>{form.errors.country}</FormErrorMessage>
                                            </div>
                                        </div>
                                    </FormControl>
                                )}
                            </Field>
                            <Field name='port'>
                                {({ field, form }: any) => (
                                    <FormControl isInvalid={form.errors.port && form.touched.port} style={{ marginBottom: 15 }}>
                                        <div className="form-field-container">
                                            <FormLabel className="form-label">Port<span style={{ color: 'red' }}>*</span></FormLabel>
                                            <div className="form-input-container">
                                                <Input {...field} placeholder='Port' className="form-input" isDisabled={isSubmitting} />
                                                <FormErrorMessage>{form.errors.port}</FormErrorMessage>
                                            </div>
                                        </div>
                                    </FormControl>
                                )}
                            </Field>
                            <Field name='jobDescription'>
                                {({ field, form }: any) => (
                                    <FormControl isInvalid={form.errors.jobDescription && form.touched.jobDescription} style={{ marginBottom: 15 }}>
                                        <div className="form-field-container">
                                            <FormLabel className="form-label">Job Description<span style={{ color: 'red' }}>*</span></FormLabel>
                                            <div className="form-input-container">
                                                <Textarea {...field} placeholder='Job Description' className="form-input" disabled={isSubmitting} />
                                                <FormErrorMessage>{form.errors.jobDescription}</FormErrorMessage>
                                            </div>
                                        </div>
                                    </FormControl>
                                )}
                            </Field>
                            <Field name='currency'>
                                {({ form }: any) => (
                                    <FormControl isInvalid={form.errors.currency && form.touched.currency} style={{ marginBottom: 15 }}>
                                        <div className="form-field-container">
                                            <FormLabel htmlFor='status-switch' className="form-label">
                                                Currency<span style={{ color: 'red' }}>*</span>
                                            </FormLabel>
                                            <div className="form-input-container">
                                                <SelectCurrency
                                                    name='currency'
                                                    placeholder="Choose Currency"
                                                    handleChange={({ value }: any) => handleChangeCurrency(props, value)}
                                                    value={props.values.currency}
                                                    defaultValue={props.values.currency}
                                                    hasError={form.errors.currency && form.touched.currency}
                                                    isDisabled={isSubmitting}
                                                    width="100%"
                                                />
                                                <FormErrorMessage>{form.errors.currency}</FormErrorMessage>
                                            </div>
                                        </div>
                                    </FormControl>
                                )}
                            </Field>
                            <Field name='costInspection'>
                                {({ field, form }: any) => (
                                    <FormControl isInvalid={form.errors.costInspection && form.touched.costInspection} style={{ marginBottom: 15 }}>
                                        <div className="form-field-container">
                                            <FormLabel className="form-label">Cost Inspection<span style={{ color: 'red' }}>*</span></FormLabel>
                                            <div className="form-input-container">
                                                <CurrencyInput
                                                    {...field}
                                                    placeholder='Input Cost'
                                                    prefix={prefix}
                                                    value={props.values.costInspection}
                                                    error={form.errors.costInspection && form.touched.costInspection}
                                                    onValueChange={({ floatValue }: any) => handleChangeCostInspection(floatValue, props.setFieldValue)}
                                                    disabled={isSubmitting}
                                                    width="100%"
                                                />
                                                <FormErrorMessage>{form.errors.costInspection}</FormErrorMessage>
                                            </div>
                                        </div>
                                    </FormControl>
                                )}
                            </Field>
                            <Field name='awaitingDays'>
                                {({ field, form }: any) => (
                                    <FormControl isInvalid={form.errors.awaitingDays && form.touched.awaitingDays} style={{ marginBottom: 15 }}>
                                        <div className="form-field-container">
                                            <FormLabel className="form-label">Awaiting Days</FormLabel>
                                            <div className="form-input-container">
                                                <div>
                                                    <CurrencyInput
                                                        {...field}
                                                        placeholder='Input'
                                                        prefix=''
                                                        value={props.values.awaitingDays}
                                                        onValueChange={({ floatValue }: any) => handleChangeAwaitingDays(floatValue, props.setFieldValue)}
                                                        disabled={isSubmitting}
                                                        width='10em'
                                                        
                                                    />
                                                    <span style={{ marginLeft: '5px' }}>Days</span>
                                                </div>
                                                
                                                <FormErrorMessage>{form.errors.awaitingDays}</FormErrorMessage>
                                            </div>
                                        </div>
                                    </FormControl>
                                )}
                            </Field>
                            <Field name='awaitingCost'>
                                {({ field, form }: any) => (
                                    <FormControl isInvalid={form.errors.awaitingCost && form.touched.awaitingCost} style={{ marginBottom: 15 }}>
                                        <div className="form-field-container">
                                            <FormLabel className="form-label"></FormLabel>
                                            <div className="form-input-container">
                                                <div>
                                                    <CurrencyInput
                                                        {...field}
                                                        placeholder='Input Cost'
                                                        prefix={prefix}
                                                        value={props.values.awaitingCost}
                                                        onValueChange={({ floatValue }: any) => handleChangeAwaitingCost(floatValue, props.setFieldValue)}
                                                        disabled={isSubmitting}
                                                        width='10em'
                                                    />
                                                    <span style={{ marginLeft: '5px' }}>/ Day</span>
                                                </div>
                                                <FormErrorMessage>{form.errors.awaitingCost}</FormErrorMessage>
                                            </div>
                                        </div>
                                    </FormControl>
                                )}
                            </Field>
                            <Field name='other1'>
                                {({ field, form }: any) => (
                                    <FormControl isInvalid={form.errors.other1 && form.touched.other1} style={{ marginBottom: 15 }}>
                                        <div className="form-field-container">
                                            <FormLabel className="form-label">Others</FormLabel>
                                            <div className="form-input-container">
                                                <Textarea {...field} placeholder='Description' className="form-input" isDisabled={isSubmitting} />
                                                <FormErrorMessage>{form.errors.other1}</FormErrorMessage>
                                            </div>
                                        </div>
                                    </FormControl>
                                )}
                            </Field>
                            <Field name='otherCost1'>
                                {({ field, form }: any) => (
                                    <FormControl isInvalid={form.errors.otherCost1 && form.touched.otherCost1} style={{ marginBottom: 15 }}>
                                        <div className="form-field-container">
                                            <FormLabel className="form-label"></FormLabel>
                                            <div className="form-input-container">
                                                <CurrencyInput
                                                    {...field}
                                                    placeholder='Input Cost'
                                                    prefix={prefix}
                                                    value={props.values.otherCost1}
                                                    error={form.errors.otherCost1 && form.touched.otherCost1}
                                                    onValueChange={({ floatValue }: any) => handleChangeOtherCost(1, floatValue, props.setFieldValue)}
                                                    disabled={isSubmitting}
                                                    width="100%"
                                                />
                                                <FormErrorMessage>{form.errors.otherCost1}</FormErrorMessage>
                                            </div>
                                        </div>
                                    </FormControl>
                                )}
                            </Field>
                            <Field name='otherCostFile1'>
                                {({ form }: any) => (
                                    <FormControl isInvalid={form.errors.otherCostFile1 && form.submitCount} style={{ marginBottom: 15 }}>
                                        <div className="form-field-container">
                                            <FormLabel className="form-label"></FormLabel>
                                            <div className="form-input-container">
                                                <FileUploader onDrop={(e) => props.setFieldValue('otherCostFile1', e[0])} isInvalid={form.errors.otherCostFile1 && form.submitCount} isDisabled={props.isSubmitting} type="supporting-files" />
                                                <FormErrorMessage>{form.errors.otherCostFile1}</FormErrorMessage>
                                                {!visibleOthers.includes(2) && <AddOthersIcon style={{ marginTop: '7px', marginLeft: '7px', cursor: 'pointer' }} onClick={() => handleAddOthers(1, props.isSubmitting)} />}
                                            </div>
                                        </div>
                                    </FormControl>
                                )}
                            </Field>
                            {visibleOthers.includes(2) &&
                                <>
                                    <Field name='other2'>
                                        {({ field, form }: any) => (
                                            <FormControl isInvalid={form.errors.other2 && form.touched.other2} style={{ marginBottom: 15 }}>
                                                <div className="form-field-container">
                                                    <FormLabel className="form-label">Others</FormLabel>
                                                    <div className="form-input-container">
                                                        <Textarea {...field} placeholder='Description' className="form-input" isDisabled={isSubmitting} />
                                                        <FormErrorMessage>{form.errors.other2}</FormErrorMessage>
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                    <Field name='otherCost2'>
                                        {({ field, form }: any) => (
                                            <FormControl isInvalid={form.errors.otherCost2 && form.touched.otherCost2} style={{ marginBottom: 15 }}>
                                                <div className="form-field-container">
                                                    <FormLabel className="form-label"></FormLabel>
                                                    <div className="form-input-container">
                                                        <CurrencyInput
                                                            {...field}
                                                            placeholder='Input Cost'
                                                            prefix={prefix}
                                                            value={props.values.otherCost2}
                                                            error={form.errors.otherCost2 && form.touched.otherCost2}
                                                            onValueChange={({ floatValue }: any) => handleChangeOtherCost(2, floatValue, props.setFieldValue)}
                                                            disabled={isSubmitting}
                                                        />
                                                        <FormErrorMessage>{form.errors.otherCost2}</FormErrorMessage>
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                    <Field name='otherCostFile2'>
                                        {({ form }: any) => (
                                            <FormControl isInvalid={form.errors.otherCostFile2 && form.submitCount} style={{ marginBottom: 15 }}>
                                                <div className="form-field-container">
                                                    <FormLabel className="form-label"></FormLabel>
                                                    <div className="form-input-container">
                                                        <FileUploader onDrop={(e) => props.setFieldValue('otherCostFile2', e[0])} isInvalid={form.errors.otherCostFile2 && form.submitCount} isDisabled={props.isSubmitting} type="supporting-files" />
                                                        <FormErrorMessage>{form.errors.otherCostFile2}</FormErrorMessage>
                                                        {!visibleOthers.includes(3) && <div style={{ flexDirection: 'row' }}>
                                                            <AddOthersIcon style={{ marginTop: '7px', marginLeft: '7px', cursor: 'pointer', display: 'inline' }} onClick={() => handleAddOthers(2, isSubmitting)} />
                                                            <RemoveOthersIcon style={{ marginTop: '7px', marginLeft: '7px', cursor: 'pointer', display: 'inline' }} onClick={() => handleRemoveOthers(2, isSubmitting)} />
                                                        </div>}
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                </>
                            }
                            {visibleOthers.includes(3) &&
                                <>
                                    <Field name='other3'>
                                        {({ field, form }: any) => (
                                            <FormControl isInvalid={form.errors.other3 && form.touched.other3} style={{ marginBottom: 15 }}>
                                                <div className="form-field-container">
                                                    <FormLabel className="form-label">Others</FormLabel>
                                                    <div className="form-input-container">
                                                        <Textarea {...field} placeholder='Description' className="form-input" isDisabled={isSubmitting} />
                                                        <FormErrorMessage>{form.errors.other3}</FormErrorMessage>
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                    <Field name='otherCost3'>
                                        {({ field, form }: any) => (
                                            <FormControl isInvalid={form.errors.otherCost3 && form.touched.otherCost3} style={{ marginBottom: 15 }}>
                                                <div className="form-field-container">
                                                    <FormLabel className="form-label"></FormLabel>
                                                    <div className="form-input-container">
                                                        <CurrencyInput
                                                            {...field}
                                                            placeholder='Input Cost'
                                                            prefix={prefix}
                                                            value={props.values.otherCost3}
                                                            error={form.errors.otherCost3 && form.touched.otherCost3}
                                                            onValueChange={({ floatValue }: any) => handleChangeOtherCost(3, floatValue, props.setFieldValue)}
                                                            disabled={isSubmitting}
                                                        />
                                                        <FormErrorMessage>{form.errors.otherCost3}</FormErrorMessage>
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                    <Field name='otherCostFile3'>
                                        {({ form }: any) => (
                                            <FormControl isInvalid={form.errors.otherCostFile3 && form.submitCount} style={{ marginBottom: 15 }}>
                                                <div className="form-field-container">
                                                    <FormLabel className="form-label"></FormLabel>
                                                    <div className="form-input-container">
                                                        <FileUploader onDrop={(e) => props.setFieldValue('otherCostFile3', e[0])} isInvalid={form.errors.otherCostFile3 && form.submitCount} isDisabled={props.isSubmitting} type="supporting-files" />
                                                        <FormErrorMessage>{form.errors.otherCostFile3}</FormErrorMessage>
                                                        {!visibleOthers.includes(4) && <div style={{ flexDirection: 'row' }}>
                                                            <AddOthersIcon style={{ marginTop: '7px', marginLeft: '7px', cursor: 'pointer', display: 'inline' }} onClick={() => handleAddOthers(3, isSubmitting)} />
                                                            <RemoveOthersIcon style={{ marginTop: '7px', marginLeft: '7px', cursor: 'pointer', display: 'inline' }} onClick={() => handleRemoveOthers(3, isSubmitting)} />
                                                        </div>}
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                </>
                            }
                            {visibleOthers.includes(4) &&
                                <>
                                    <Field name='other4'>
                                        {({ field, form }: any) => (
                                            <FormControl isInvalid={form.errors.other4 && form.touched.other4} style={{ marginBottom: 15 }}>
                                                <div className="form-field-container">
                                                    <FormLabel className="form-label">Others</FormLabel>
                                                    <div className="form-input-container">
                                                        <Textarea {...field} placeholder='Description' className="form-input" isDisabled={isSubmitting} />
                                                        <FormErrorMessage>{form.errors.other4}</FormErrorMessage>
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                    <Field name='otherCost4'>
                                        {({ field, form }: any) => (
                                            <FormControl isInvalid={form.errors.otherCost4 && form.touched.otherCost4} style={{ marginBottom: 15 }}>
                                                <div className="form-field-container">
                                                    <FormLabel className="form-label"></FormLabel>
                                                    <div className="form-input-container">
                                                        <CurrencyInput
                                                            {...field}
                                                            placeholder='Input Cost'
                                                            prefix={prefix}
                                                            value={props.values.otherCost4}
                                                            error={form.errors.otherCost4 && form.touched.otherCost4}
                                                            onValueChange={({ floatValue }: any) => handleChangeOtherCost(4, floatValue, props.setFieldValue)}
                                                            disabled={isSubmitting}
                                                        />
                                                        <FormErrorMessage>{form.errors.otherCost4}</FormErrorMessage>
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                    <Field name='otherCostFile4'>
                                        {({ form }: any) => (
                                            <FormControl isInvalid={form.errors.otherCostFile4 && form.submitCount} style={{ marginBottom: 15 }}>
                                                <div className="form-field-container">
                                                    <FormLabel className="form-label"></FormLabel>
                                                    <div className="form-input-container">
                                                        <FileUploader onDrop={(e) => props.setFieldValue('otherCostFile4', e[0])} isInvalid={form.errors.otherCostFile4 && form.submitCount} isDisabled={props.isSubmitting} type="supporting-files" />
                                                        <FormErrorMessage>{form.errors.otherCostFile4}</FormErrorMessage>
                                                        {!visibleOthers.includes(5) && <div style={{ flexDirection: 'row' }}>
                                                            <AddOthersIcon style={{ marginTop: '7px', marginLeft: '7px', cursor: 'pointer', display: 'inline' }} onClick={() => handleAddOthers(4, isSubmitting)} />
                                                            <RemoveOthersIcon style={{ marginTop: '7px', marginLeft: '7px', cursor: 'pointer', display: 'inline' }} onClick={() => handleRemoveOthers(4, isSubmitting)} />
                                                        </div>}
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                </>
                            }
                            {visibleOthers.includes(5) &&
                                <>
                                    <Field name='other5'>
                                        {({ field, form }: any) => (
                                            <FormControl isInvalid={form.errors.other5 && form.touched.other5} style={{ marginBottom: 15 }}>
                                                <div className="form-field-container">
                                                    <FormLabel className="form-label">Others</FormLabel>
                                                    <div className="form-input-container">
                                                        <Textarea {...field} placeholder='Description' className="form-input" isDisabled={isSubmitting} />
                                                        <FormErrorMessage>{form.errors.other5}</FormErrorMessage>
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                    <Field name='otherCost5'>
                                        {({ field, form }: any) => (
                                            <FormControl isInvalid={form.errors.otherCost5 && form.touched.otherCost5} style={{ marginBottom: 15 }}>
                                                <div className="form-field-container">
                                                    <FormLabel className="form-label"></FormLabel>
                                                    <div className="form-input-container">
                                                        <CurrencyInput
                                                            {...field}
                                                            placeholder='Input Cost'
                                                            prefix={prefix}
                                                            value={props.values.otherCost5}
                                                            error={form.errors.otherCost5 && form.touched.otherCost5}
                                                            onValueChange={({ floatValue }: any) => handleChangeOtherCost(5, floatValue, props.setFieldValue)}
                                                            disabled={isSubmitting}
                                                        />
                                                        <FormErrorMessage>{form.errors.otherCost5}</FormErrorMessage>
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                    <Field name='otherCostFile5'>
                                        {({ form }: any) => (
                                            <FormControl isInvalid={form.errors.otherCostFile5 && form.submitCount} style={{ marginBottom: 15 }}>
                                                <div className="form-field-container">
                                                    <FormLabel className="form-label"></FormLabel>
                                                    <div className="form-input-container">
                                                        <FileUploader onDrop={(e) => props.setFieldValue('otherCostFile5', e[0])} isInvalid={form.errors.otherCostFile5 && form.submitCount} isDisabled={props.isSubmitting} type="supporting-files" />
                                                        <FormErrorMessage>{form.errors.otherCostFile5}</FormErrorMessage>
                                                        {!visibleOthers.includes(6) && <div style={{ flexDirection: 'row' }}>
                                                            <AddOthersIcon style={{ marginTop: '7px', marginLeft: '7px', cursor: 'pointer', display: 'inline' }} onClick={() => handleAddOthers(5, isSubmitting)} />
                                                            <RemoveOthersIcon style={{ marginTop: '7px', marginLeft: '7px', cursor: 'pointer', display: 'inline' }} onClick={() => handleRemoveOthers(5, isSubmitting)} />
                                                        </div>}
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                </>
                            }
                            {visibleOthers.includes(6) &&
                                <>
                                    <Field name='other6'>
                                        {({ field, form }: any) => (
                                            <FormControl isInvalid={form.errors.other6 && form.touched.other6} style={{ marginBottom: 15 }}>
                                                <div className="form-field-container">
                                                    <FormLabel className="form-label">Others</FormLabel>
                                                    <div className="form-input-container">
                                                        <Textarea {...field} placeholder='Description' className="form-input" isDisabled={isSubmitting} />
                                                        <FormErrorMessage>{form.errors.other6}</FormErrorMessage>
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                    <Field name='otherCost6'>
                                        {({ field, form }: any) => (
                                            <FormControl isInvalid={form.errors.otherCost6 && form.touched.otherCost6} style={{ marginBottom: 15 }}>
                                                <div className="form-field-container">
                                                    <FormLabel className="form-label"></FormLabel>
                                                    <div className="form-input-container">
                                                        <CurrencyInput
                                                            {...field}
                                                            placeholder='Input Cost'
                                                            prefix={prefix}
                                                            value={props.values.otherCost6}
                                                            error={form.errors.otherCost6 && form.touched.otherCost6}
                                                            onValueChange={({ floatValue }: any) => handleChangeOtherCost(6, floatValue, props.setFieldValue)}
                                                            disabled={isSubmitting}
                                                        />
                                                        <FormErrorMessage>{form.errors.otherCost6}</FormErrorMessage>
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                    <Field name='otherCostFile6'>
                                        {({ form }: any) => (
                                            <FormControl isInvalid={form.errors.otherCostFile6 && form.submitCount} style={{ marginBottom: 15 }}>
                                                <div className="form-field-container">
                                                    <FormLabel className="form-label"></FormLabel>
                                                    <div className="form-input-container">
                                                        <FileUploader onDrop={(e) => props.setFieldValue('otherCostFile6', e[0])} isInvalid={form.errors.otherCostFile6 && form.submitCount} isDisabled={props.isSubmitting} type="supporting-files" />
                                                        <FormErrorMessage>{form.errors.otherCostFile6}</FormErrorMessage>
                                                        {!visibleOthers.includes(7) && <div style={{ flexDirection: 'row' }}>
                                                            <AddOthersIcon style={{ marginTop: '7px', marginLeft: '7px', cursor: 'pointer', display: 'inline' }} onClick={() => handleAddOthers(6, isSubmitting)} />
                                                            <RemoveOthersIcon style={{ marginTop: '7px', marginLeft: '7px', cursor: 'pointer', display: 'inline' }} onClick={() => handleRemoveOthers(6, isSubmitting)} />
                                                        </div>}
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                </>
                            }
                            {visibleOthers.includes(7) &&
                                <>
                                    <Field name='other7'>
                                        {({ field, form }: any) => (
                                            <FormControl isInvalid={form.errors.other7 && form.touched.other7} style={{ marginBottom: 15 }}>
                                                <div className="form-field-container">
                                                    <FormLabel className="form-label">Others</FormLabel>
                                                    <div className="form-input-container">
                                                        <Textarea {...field} placeholder='Description' className="form-input" isDisabled={isSubmitting} />
                                                        <FormErrorMessage>{form.errors.other7}</FormErrorMessage>
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                    <Field name='otherCost7'>
                                        {({ field, form }: any) => (
                                            <FormControl isInvalid={form.errors.otherCost7 && form.touched.otherCost7} style={{ marginBottom: 15 }}>
                                                <div className="form-field-container">
                                                    <FormLabel className="form-label"></FormLabel>
                                                    <div className="form-input-container">
                                                        <CurrencyInput
                                                            {...field}
                                                            placeholder='Input Cost'
                                                            prefix={prefix}
                                                            value={props.values.otherCost7}
                                                            error={form.errors.otherCost7 && form.touched.otherCost7}
                                                            onValueChange={({ floatValue }: any) => handleChangeOtherCost(7, floatValue, props.setFieldValue)}
                                                            disabled={isSubmitting}
                                                        />
                                                        <FormErrorMessage>{form.errors.otherCost7}</FormErrorMessage>
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                    <Field name='otherCostFile7'>
                                        {({ form }: any) => (
                                            <FormControl isInvalid={form.errors.otherCostFile7 && form.submitCount} style={{ marginBottom: 15 }}>
                                                <div className="form-field-container">
                                                    <FormLabel className="form-label"></FormLabel>
                                                    <div className="form-input-container">
                                                        <FileUploader onDrop={(e) => props.setFieldValue('otherCostFile7', e[0])} isInvalid={form.errors.otherCostFile7 && form.submitCount} isDisabled={props.isSubmitting} type="supporting-files" />
                                                        <FormErrorMessage>{form.errors.otherCostFile7}</FormErrorMessage>
                                                        {!visibleOthers.includes(8) && <div style={{ flexDirection: 'row' }}>
                                                            <AddOthersIcon style={{ marginTop: '7px', marginLeft: '7px', cursor: 'pointer', display: 'inline' }} onClick={() => handleAddOthers(7, isSubmitting)} />
                                                            <RemoveOthersIcon style={{ marginTop: '7px', marginLeft: '7px', cursor: 'pointer', display: 'inline' }} onClick={() => handleRemoveOthers(7, isSubmitting)} />
                                                        </div>}
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                </>
                            }
                            {visibleOthers.includes(8) &&
                                <>
                                    <Field name='other8'>
                                        {({ field, form }: any) => (
                                            <FormControl isInvalid={form.errors.other8 && form.touched.other8} style={{ marginBottom: 15 }}>
                                                <div className="form-field-container">
                                                    <FormLabel className="form-label">Others</FormLabel>
                                                    <div className="form-input-container">
                                                        <Textarea {...field} placeholder='Description' className="form-input" isDisabled={isSubmitting} />
                                                        <FormErrorMessage>{form.errors.other8}</FormErrorMessage>
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                    <Field name='otherCost8'>
                                        {({ field, form }: any) => (
                                            <FormControl isInvalid={form.errors.otherCost8 && form.touched.otherCost8} style={{ marginBottom: 15 }}>
                                                <div className="form-field-container">
                                                    <FormLabel className="form-label"></FormLabel>
                                                    <div className="form-input-container">
                                                        <CurrencyInput
                                                            {...field}
                                                            placeholder='Input Cost'
                                                            prefix={prefix}
                                                            value={props.values.otherCost8}
                                                            error={form.errors.otherCost8 && form.touched.otherCost8}
                                                            onValueChange={({ floatValue }: any) => handleChangeOtherCost(8, floatValue, props.setFieldValue)}
                                                            disabled={isSubmitting}
                                                        />
                                                        <FormErrorMessage>{form.errors.otherCost8}</FormErrorMessage>
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                    <Field name='otherCostFile8'>
                                        {({ form }: any) => (
                                            <FormControl isInvalid={form.errors.otherCostFile8 && form.submitCount} style={{ marginBottom: 15 }}>
                                                <div className="form-field-container">
                                                    <FormLabel className="form-label"></FormLabel>
                                                    <div className="form-input-container">
                                                        <FileUploader onDrop={(e) => props.setFieldValue('otherCostFile8', e[0])} isInvalid={form.errors.otherCostFile8 && form.submitCount} isDisabled={props.isSubmitting} type="supporting-files" />
                                                        <FormErrorMessage>{form.errors.otherCostFile8}</FormErrorMessage>
                                                        {!visibleOthers.includes(9) && <div style={{ flexDirection: 'row' }}>
                                                            <AddOthersIcon style={{ marginTop: '7px', marginLeft: '7px', cursor: 'pointer', display: 'inline' }} onClick={() => handleAddOthers(8, isSubmitting)} />
                                                            <RemoveOthersIcon style={{ marginTop: '7px', marginLeft: '7px', cursor: 'pointer', display: 'inline' }} onClick={() => handleRemoveOthers(8, isSubmitting)} />
                                                        </div>}
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                </>
                            }
                            {visibleOthers.includes(9) &&
                                <>
                                    <Field name='other9'>
                                        {({ field, form }: any) => (
                                            <FormControl isInvalid={form.errors.other9 && form.touched.other9} style={{ marginBottom: 15 }}>
                                                <div className="form-field-container">
                                                    <FormLabel className="form-label">Others</FormLabel>
                                                    <div className="form-input-container">
                                                        <Textarea {...field} placeholder='Description' className="form-input" isDisabled={isSubmitting} />
                                                        <FormErrorMessage>{form.errors.other9}</FormErrorMessage>
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                    <Field name='otherCost9'>
                                        {({ field, form }: any) => (
                                            <FormControl isInvalid={form.errors.otherCost9 && form.touched.otherCost9} style={{ marginBottom: 15 }}>
                                                <div className="form-field-container">
                                                    <FormLabel className="form-label"></FormLabel>
                                                    <div className="form-input-container">
                                                        <CurrencyInput
                                                            {...field}
                                                            placeholder='Input Cost'
                                                            prefix={prefix}
                                                            value={props.values.otherCost9}
                                                            error={form.errors.otherCost9 && form.touched.otherCost9}
                                                            onValueChange={({ floatValue }: any) => handleChangeOtherCost(9, floatValue, props.setFieldValue)}
                                                            disabled={isSubmitting}
                                                        />
                                                        <FormErrorMessage>{form.errors.otherCost9}</FormErrorMessage>
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                    <Field name='otherCostFile9'>
                                        {({ form }: any) => (
                                            <FormControl isInvalid={form.errors.otherCostFile9 && form.submitCount} style={{ marginBottom: 15 }}>
                                                <div className="form-field-container">
                                                    <FormLabel className="form-label"></FormLabel>
                                                    <div className="form-input-container">
                                                        <FileUploader onDrop={(e) => props.setFieldValue('otherCostFile9', e[0])} isInvalid={form.errors.otherCostFile9 && form.submitCount} isDisabled={props.isSubmitting} type="supporting-files" />
                                                        <FormErrorMessage>{form.errors.otherCostFile9}</FormErrorMessage>
                                                        {!visibleOthers.includes(10) && <div style={{ flexDirection: 'row' }}>
                                                            <AddOthersIcon style={{ marginTop: '7px', marginLeft: '7px', cursor: 'pointer', display: 'inline' }} onClick={() => handleAddOthers(9, isSubmitting)} />
                                                            <RemoveOthersIcon style={{ marginTop: '7px', marginLeft: '7px', cursor: 'pointer', display: 'inline' }} onClick={() => handleRemoveOthers(9, isSubmitting)} />
                                                        </div>}
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                </>
                            }
                            {visibleOthers.includes(10) &&
                                <>
                                    <Field name='other10'>
                                        {({ field, form }: any) => (
                                            <FormControl isInvalid={form.errors.other10 && form.touched.other10} style={{ marginBottom: 15 }}>
                                                <div className="form-field-container">
                                                    <FormLabel className="form-label">Others</FormLabel>
                                                    <div className="form-input-container">
                                                        <Textarea {...field} placeholder='Description' className="form-input" isDisabled={isSubmitting} />
                                                        <FormErrorMessage>{form.errors.other10}</FormErrorMessage>
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                    <Field name='otherCost10'>
                                        {({ field, form }: any) => (
                                            <FormControl isInvalid={form.errors.otherCost10 && form.touched.otherCost10} style={{ marginBottom: 15 }}>
                                                <div className="form-field-container">
                                                    <FormLabel className="form-label"></FormLabel>
                                                    <div className="form-input-container">
                                                        <CurrencyInput
                                                            {...field}
                                                            placeholder='Input Cost'
                                                            prefix={prefix}
                                                            value={props.values.otherCost10}
                                                            error={form.errors.otherCost10 && form.touched.otherCost10}
                                                            onValueChange={({ floatValue }: any) => handleChangeOtherCost(10, floatValue, props.setFieldValue)}
                                                            disabled={isSubmitting}
                                                        />
                                                        <FormErrorMessage>{form.errors.otherCost10}</FormErrorMessage>
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                    <Field name='otherCostFile10'>
                                        {({ form }: any) => (
                                            <FormControl isInvalid={form.errors.otherCostFile10 && form.submitCount} style={{ marginBottom: 15 }}>
                                                <div className="form-field-container">
                                                    <FormLabel className="form-label"></FormLabel>
                                                    <div className="form-input-container">
                                                        <FileUploader onDrop={(e) => props.setFieldValue('otherCostFile10', e[0])} isInvalid={form.errors.otherCostFile10 && form.submitCount} isDisabled={props.isSubmitting} type="supporting-files" />
                                                        <FormErrorMessage>{form.errors.otherCostFile10}</FormErrorMessage>
                                                        <RemoveOthersIcon style={{ marginTop: '7px', marginLeft: '7px', cursor: 'pointer' }} onClick={() => handleRemoveOthers(10, isSubmitting)} />
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                </>
                            }
                            <Field name='totalAmount'>
                                {({ field, form }: any) => (
                                    <FormControl isInvalid={form.errors.totalAmount && form.touched.totalAmount} style={{ marginBottom: 15 }}>
                                        <div className="form-field-container">
                                            <FormLabel className="form-label">Total Amount<span style={{ color: 'red' }}>*</span></FormLabel>
                                            <div className="form-input-container">
                                                <CurrencyInput
                                                    {...field}
                                                    placeholder='Total Amount'
                                                    prefix={prefix}
                                                    value={total}
                                                    width="100%"
                                                    disabled
                                                />
                                                <FormErrorMessage>{form.errors.totalAmount}</FormErrorMessage>
                                            </div>
                                        </div>
                                    </FormControl>
                                )}
                            </Field>
                            <Field name='inspectionResult'>
                                {({ form }: any) => (
                                    <FormControl isInvalid={form.errors.inspectionResult && form.touched.inspectionResult} style={{ marginBottom: 15 }}>
                                        <div className="form-field-container">
                                            <FormLabel className="form-label">Inspection Result</FormLabel>
                                            <div className="form-input-container">
                                                <FileUploader onDrop={(e) => props.setFieldValue('inspectionResult', e[0])} isInvalid={form.errors.inspectionResult && form.touched.inspectionResult} isDisabled={props.isSubmitting} type="inspection-result" />
                                                <FormErrorMessage>{form.errors.inspectionResult}</FormErrorMessage>
                                            </div>
                                        </div>
                                    </FormControl>
                                )}
                            </Field>
                            <Field name='files'>
                                {({ form }: any) => (
                                    <FormControl isInvalid={form.errors.files && form.submitCount} style={{ marginBottom: 15 }}>
                                        <div className="form-field-container">
                                            <FormLabel className="form-label">Invoice Files<span style={{ color: 'red' }}>*</span></FormLabel>
                                            <div className="form-input-container">
                                                <FileUploader onDrop={(e) => handleDrop(e, 'files', props.setFieldValue)} isInvalid={form.errors.files && form.submitCount} isDisabled={props.isSubmitting} type="supporting-files" />
                                                <FormErrorMessage>{form.errors.files}</FormErrorMessage>
                                            </div>
                                        </div>
                                    </FormControl>
                                )}
                            </Field>

                            <Divider />
                            <div style={{ display: 'flex', justifyContent: 'flex-end', flexWrap: 'wrap', gap: 10 }}>
                                <Button
                                    mt={4}
                                    bgColor='white'
                                    borderColor='#D0D5DD'
                                    isLoading={isSubmitting}
                                    onClick={handleCancel}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    mt={4}
                                    bgColor='white'
                                    borderColor='#D0D5DD'
                                    isLoading={isSubmitting}
                                    onClick={() => setIsDraft(true)}
                                    type='submit'
                                >
                                    Save as Draft
                                </Button>
                                <Button
                                    mt={4}
                                    bgColor={COLORS.BUTTON.BACKGROUND}
                                    color={COLORS.BUTTON.FOREGROUND}
                                    isLoading={isSubmitting}
                                    onClick={() => setIsDraft(false)}
                                    type='submit'
                                    rightIcon={<ArrowIcon />}
                                >
                                    Create New Invoice
                                </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </>
    )
}

export default AddInvoicesInspector;
